export default __webpack_public_path__ + "static/media/market-value-icon.929b71b4.svg";